import { useState, useRef } from "react";
import classnames from "classnames";
import AccountIcon from "components/svg/AccountIcon";
import SignOutButton from "./TheHeaderSignoutButton";
import LanguageSelector from "./TheHeaderLanguages";
import FeedbackLinks from "./TheHeaderFeedback";
import useOnClickOutside from "customHooks/useOnClickOutside";

interface Props {
  isUserExternal: boolean;
  userHasAuthenticated: (isAuthenticated: boolean) => void;
}

const TheHeaderSettings = ({ isUserExternal, userHasAuthenticated }: Props) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const feedbackContainerRef = useRef<HTMLDivElement>(null);

  useOnClickOutside({
    refs: [containerRef, feedbackContainerRef],
    handler: () => {
      setIsSettingsOpen(false);
      setIsAccordionOpen(false);
    },
  });

  return (
    <div className="header-settings" ref={containerRef}>
      <button
        className={classnames("header-settings__toggler", {
          "header-settings__toggler--is-active": isSettingsOpen,
        })}
        onClick={() => setIsSettingsOpen((prev) => !prev)}
      >
        <AccountIcon fill="white" width={23} height={23} />
      </button>
      {isSettingsOpen && (
        <div className="header-settings__actions-container">
          <div
            className={classnames("header-settings-language", {
              "header-settings-language--is-open": isAccordionOpen,
            })}
          >
            <LanguageSelector />
            <div ref={feedbackContainerRef}>
              <FeedbackLinks isUserExternal={isUserExternal} />
              <SignOutButton userHasAuthenticated={userHasAuthenticated} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TheHeaderSettings;
